<template>
  <div>
    <div class="loading" v-if="loading">
      <md-progress-spinner class="md-accent" :md-diameter="100" :md-stroke="10" md-mode="indeterminate"></md-progress-spinner>
    </div>
    <div class="loading" v-if="!loading && errorMessage !== null">
      {{errorMessage}}
    </div>
    <div class="loading" v-if="!loading && errorMessage === null">

      <md-card>
        <md-card-header>
          <div class="md-title">Staff</div>
        </md-card-header>

        <md-card-content>
          <md-table>

            <md-table-row v-if="staffList && staffList.length > 0">
              <md-table-head md-sort-name="name">Name</md-table-head>
              <md-table-head>Initials</md-table-head>
              <md-table-head>Color</md-table-head>
              <md-table-head>Enabled</md-table-head>
            </md-table-row>

            <!--<tr class="md-table-row" v-for="city in cities" :key="city.versionedId.id" v-on:click="editCity(city)">-->
            <md-table-row v-for="object in staffList" :key="object.versionedId.id" >
              <md-table-cell>
                <span v-if="!object.edit">{{object.name}}</span>
                <span v-if="object.edit">
                  <md-field>
                    <md-input v-focus v-model="object.name" @keyup.enter="saveObject(object)" @keyup.esc="cancelEditObject(object)" maxlength="255"></md-input>
                    <md-icon style="color: red;" v-if="isSoftLocked(object.versionedId.id)"><md-tooltip md-direction="bottom">{{getLockedByString(object.versionedId.id)}}</md-tooltip>warning</md-icon>
                    <span class="md-helper-text">{{object.oldObject.name}}</span>
                  </md-field>
                </span>
              </md-table-cell>

              <md-table-cell>
                <span v-if="!object.edit">{{object.initials}}</span>
                <span v-if="object.edit">
                  <md-field>
                    <md-input v-model="object.initials" @keyup.enter="saveObject(object)" @keyup.esc="cancelEditObject(object)" maxlength="255"></md-input>
                    <md-icon style="color: red;" v-if="isSoftLocked(object.versionedId.id)"><md-tooltip md-direction="bottom">{{getLockedByString(object.versionedId.id)}}</md-tooltip>warning</md-icon>
                    <span class="md-helper-text">{{object.oldObject.initials}}</span>
                  </md-field>
                </span>
              </md-table-cell>

              <md-table-cell style="max-width: 170px">
                <span v-if="!object.edit && object.color && object.color !== 'DEFAULT'">
                  <md-icon class="md-size-2x" :style="'color: ' + object.color">style</md-icon>
                </span>
                <span v-if="object.edit">
                  <swatches v-model="object.color" :colors="colors" :disabled="!object.edit" inline :wrapper-style="{backgroundColor: 'transparent' }" row-length="3" :exceptions="otherColors(object.versionedId.id)" show-border></swatches>
                </span>
              </md-table-cell>

              <md-table-cell>
                <md-checkbox v-model="object.enabled" :disabled="!object.edit" />
              </md-table-cell>

              <md-table-cell>
                <md-button class="md-icon-button md-dense md-primary editButton" @click="editObject(object)" v-if="!object.edit"  v-bind:disabled="object.saving">
                  <md-icon class="md-morph-final">edit</md-icon>
                </md-button>
                <md-button class="md-icon-button md-dense md-primary" @click="saveObject(object)" v-if="object.edit">
                  <md-icon class="md-morph-final">save</md-icon>
                </md-button>
                <md-button class="md-icon-button md-dense md-primary" @click="cancelEditObject(object)" v-if="object.edit">
                  <md-icon class="md-morph-final">cancel</md-icon>
                </md-button>
                <!--<md-button class="md-icon-button md-dense md-primary" @click="askToDelete(object)" v-if="object.edit"  v-bind:disabled="object.saving">-->
                <!--<md-icon class="md-morph-final">delete</md-icon>-->
                <!--</md-button>-->
                <span>
                  <md-icon style="margin-top: 4px;" v-if="!object.edit && isSoftLocked(object.versionedId.id)" class="md-morph-final"><md-tooltip md-direction="bottom">{{getLockedByString(object.versionedId.id)}}</md-tooltip>warning</md-icon>
                </span>
              </md-table-cell>
            </md-table-row>
          </md-table>
        </md-card-content>
        <md-card-actions>
          <md-button class="md-primary md-raised" @click="showNewObjectDialog">New Staff</md-button>
        </md-card-actions>
      </md-card>

    </div>

    <md-dialog :md-active.sync="createPromptActive">
      <md-dialog-title>Create a new Staff</md-dialog-title>

      <div class="dialogContent">
        <md-field>
          <label>Name</label>
          <md-input ref="newObjectFirstField" v-model="newObject.name" @keyup.enter="createObject" @keyup.esc="createPromptActive = false" maxlength="255"></md-input>
        </md-field>
        <md-field >
          <label>Initials</label>
          <md-input v-model="newObject.initials" @keyup.enter="createObject" @keyup.esc="createPromptActive = false" maxlength="255"></md-input>
        </md-field>
        <md-field>
          <swatches v-model="newObject.color" :colors="colors" :exceptions="otherColors(null)" inline show-border></swatches>
          <!--<span class="md-helper-text">Color2</span>-->
        </md-field>

        <md-dialog-actions>
          <md-button class="md-primary" @click="createPromptActive = false">Cancel</md-button>
          <md-button class="md-primary md-raised" @click="createObject" v-bind:disabled="!dialogCreateActive">Create</md-button>
        </md-dialog-actions>
      </div>
    </md-dialog>

    <md-dialog-confirm
      :md-active.sync="deletePromptActive"
      md-title="Delete Staff"
      :md-content="'Are you sure you want to delete \'' + objectToDelete.name + '\'?'"
      md-confirm-text="Delete"
      md-cancel-text="Cancel"
      @md-confirm="confirmDelete" />

    <md-snackbar md-position="center" :md-duration="8000" :md-active.sync="showSnackbar" md-persistent>
      <span>{{snackbarMessage}}</span>
      <md-button class="md-accent" @click="showSnackbar = false">OK</md-button>
    </md-snackbar>
  </div>
</template>

<script>
  import Swatches from 'vue-swatches'

  export default {
    components: { Swatches },
    name: "staff",
    data() {
      var mutableFields = ['name', 'initials', 'color'];
      var newObject = {};
      mutableFields.forEach(fieldName => {
        newObject[fieldName] = '';
      });
      return {
        loading: false,
        changed: false,
        errorMessage: null,
        createPromptActive: false,
        deletePromptActive: false,
        objectToDelete: {},
        showSnackbar: false,
        snackbarMessage: '',
        newObject: newObject,
        mutableFields: mutableFields,
        // https://github.com/saintplay/vue-swatches/blob/master/src/presets/material-dark.js
        colors: [
          'DEFAULT',
          '#D32F2F',
          '#C2185B',
          '#7B1FA2',
          '#512DA8',
          '#303F9F',
          '#1976D2',
          '#0288D1',
          '#0097A7',
          '#00796B',
          '#388E3C',
          '#689F38',
          '#AFB42B',
          '#FBC02D',
          '#FFA000',
          '#F57C00',
          '#E64A19',
          '#5D4037',
          '#616161',
          '#455A64'
        ]
      }
    },
    computed: {
      staffList() {
        if (this.$store.state.currentCityDetails) {
          this.loading = false;
          if (this.changed || !this.changed) {
            this.changed = false;
            return this.$store.state.currentCityDetails.staff;
          }
        } else {
          return [];
        }
      },
      dialogCreateActive() {
        var active = true;
        this.mutableFields.forEach(fieldName => {
          if (this.newObject[fieldName].length < 1) {
            active = false;
          }
        });
        return active;
      }
    },
    methods: {
      isSoftLocked(lockId) {
        return (this.$store.state.otherUserPageLocks[lockId] !== undefined)
      },
      getLockedByString(lockId) {
        if (this.$store.state.otherUserPageLocks[lockId] !== undefined) {
          return Object.keys(this.$store.state.otherUserPageLocks[lockId]).join(', ');
        } else {
          return "";
        }
      },
      showNewObjectDialog() {
        this.mutableFields.forEach(fieldName => {
          this.newObject[fieldName] = '';
        });
        this.newObject.color = 'DEFAULT';
        this.createPromptActive = true;
        var refs = this.$refs; setTimeout(() => this.$nextTick(() => refs.newObjectFirstField.$el.focus()), 300);
      },
      createObject() {
        this.createPromptActive = false;
        this.$store.api.rpcRequest('createStaff', {
          name: this.newObject.name,
          initials: this.newObject.initials,
          color: this.newObject.color,
          cityId: this.$store.state.currentCity.versionedId.id
        }, newObject => {
        }, errorMessage => {
        });
      },
      editObject(object) {
        if (!object.edit) {
          var oldObject = Object.assign({}, object);
          object.oldObject = oldObject;
          object.edit = true;
          this.changed = true;
          this.$store.api.softLock(this.$route.fullPath, object.versionedId.id);
        }
      },
      cancelEditObject(object) {
        if (object.edit) {
          this.mutableFields.forEach(fieldName => {
            object[fieldName] = object.oldObject[fieldName];
          });
          object.edit = false;
          this.changed = true;
          this.$store.api.softUnlock(this.$route.fullPath, object.versionedId.id);
        }
      },
      saveObject(object) {
        if (object.edit) {
          this.$store.api.softUnlock(this.$route.fullPath, object.versionedId.id);
          object.edit = false;
          object.saving = true;
          this.changed = true;
          this.$store.api.rpcRequest('saveStaff', {
            versionedId: object.versionedId,
            name: object.name,
            initials: object.initials,
            color: object.color || "DEFAULT",
            enabled: object.enabled
          }, savedObject => {
            object.saving = false;
            this.changed = true;
          }, errorMessage => {
            object.edit = true;
            object.saving = false;
            this.changed = true;
            this.$store.api.softLock(this.$route.fullPath, object.versionedId.id);
          });
        }
      },
      askToDelete(object) {
        this.objectToDelete = object;
        this.deletePromptActive = true;
      },
      confirmDelete() {
        this.deleteObject(this.objectToDelete);
      },
      deleteObject(object) {
        if (object.edit) {
          this.$store.api.softUnlock(this.$route.fullPath, object.versionedId.id);
          object.edit = false;
          object.saving = true;
          this.changed = true;
          this.$store.api.rpcRequest('deleteStaff', {
            versionedId: object.versionedId
          }, savedObject => {
            object.saving = false;
            this.changed = true;
          }, errorMessage => {
            object.edit = true;
            object.saving = false;
            this.changed = true;
            this.$store.api.softLock(this.$route.fullPath, object.versionedId.id);
          });
        }
      },
      otherColors(userId) {
        var usedColors = [];
        if (this.staffList) {
          this.staffList.forEach(staff => {
            if (staff.versionedId.id !== userId && staff.color && staff.color.length > 0 && staff.color !== 'DEFAULT')
              usedColors.push(staff.color);
          })
        }
        return usedColors;
      }
    }
  }
</script>

<style scoped>
  .dialogContent {
    padding: 24px;
  }

  .md-table-head {
    text-align: center;
  }

  button.editButton { visibility: hidden;}
  tr:hover button.editButton{ visibility: visible;}

</style>



// WEBPACK FOOTER //
// src/components/city/Staff.vue